<template>
  <div class="page-content_">
    <vk-offcanvas flipped overlay stuck :show.sync="warningsOffCanvas">
      <div style="width: auto !important; overflow: scroll">
        <vk-offcanvas-close
          @click="warningsOffCanvas = false"
        ></vk-offcanvas-close>
        <h3>Warning Report</h3>
        <hr />
        <!-- {{JSON.stringify(exportDataTableoptions)}} -->
        <template style="overflow: scroll">
          <el-select
            v-model="warningsDataValuesFields"
            multiple
            placeholder="Select"
          >
            <el-option
              v-for="(item, key) in warningsDataTableoptions"
              :key="key"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </template>
        <div>
          <div class="overflow-auto">
            <b-table
              responsive
              :items="warningsData"
              :fields="warningsDataValuesFields"
              :per-page="perPage"
              :current-page="warningCurrentPage"
              small
            ></b-table>
            <b-pagination
              v-model="warningCurrentPage"
              :total-rows="warningRows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>

            <p class="mt-3">Current Page: {{ warningCurrentPage }}</p>
          </div>
        </div>
      </div>
    </vk-offcanvas>
    <vk-offcanvas flipped overlay stuck :show.sync="showTableOffCanvas">
      <div style="width: auto !important; overflow: scroll">
        <vk-offcanvas-close
          @click="showTableOffCanvas = false"
        ></vk-offcanvas-close>
        <h3>Report</h3>
        <hr />
        <!-- {{JSON.stringify(exportDataTableoptions)}} -->
        <template style="overflow: scroll">
          <el-select
            v-model="exportDataToTableValuesFields"
            multiple
            placeholder="Select"
          >
            <el-option
              v-for="(item, key) in exportDataTableoptions"
              :key="key"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </template>
        <div>
          <div class="overflow-auto">
            <b-table
              responsive
              :items="exportDataToTableValues"
              :fields="exportDataToTableValuesFields"
              :per-page="perPage"
              :current-page="currentPage"
              small
            ></b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
            ></b-pagination>

            <p class="mt-3">Current Page: {{ currentPage }}</p>
          </div>
        </div>
      </div>
    </vk-offcanvas>
    <vk-offcanvas
      v-if="initError == false"
      flipped
      overlay
      :show.sync="showOffCanvas"
    >
      <div>
        <vk-offcanvas-close @click="showOffCanvas = false"></vk-offcanvas-close>
        <!-- <h3>System details</h3>
        <hr />-->
        <!-- {{Device}} -->
        <!-- {{confirmEnergy(EnergyData)}} -->

        <el-tabs :tab-position="`top`" style="height: 100%">
          <el-tab-pane label="Inverters">
            <el-card
              style="margin-bottom: 20px"
              shadow="always"
              v-for="(singleInverter, index) in Device.InverterData"
              :key="`inverterDetails_${index}`"
            >
              <div class="inverter-details-box">
                <div
                  style="
                    width: 150px;
                    border-right: 1px solid #eee;
                    padding: 5px;
                    margin-right: 2px;
                    text-align: center;
                  "
                >
                  <!-- <img
                    :src="require('@/assets/inverter.png')"
                    style="width: 50%; height: auto"
                    alt="inv"
                  /> -->
                  <img
                    :src="
                      'https://res.cloudinary.com/mentor-africa-project/image/upload/v1634545558/Charge_Controller.jpg'
                    "
                    style="width: 50%; height: auto"
                    alt="inv"
                  />
                  <b>{{ singleInverter["InverterId"] }}</b>
                </div>
                <div
                  style="
                    flex: 1;
                    display: flex;
                    align-items: center;
                    flex-flow: column;
                    justify-content: center;
                    padding: 10px;
                  "
                >
                  <div
                    class="inverterInfo"
                    v-for="(inverterKey, index) in Object.keys(singleInverter)"
                    v-show="inverterKey != 'InverterId'"
                    :key="`inverterKey_${index}`"
                  >
                    <b>{{ getLabel(inverterKey) }}</b>
                    <span>
                      {{
                        inverterKey != "InverterId"
                          ? getDisplayValue(singleInverter, inverterKey)
                          : "--"
                      }}
                    </span>
                  </div>

                  <!-- {{JSON.stringify(Device.InverterData)}} -->
                </div>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane v-if="parseFloat(MiscData.FV) >= 1.76" label="Energy">
            <el-card
              style="margin-bottom: 20px"
              shadow="always"
              v-for="(singleEnergy, index) in singularEnergyData"
              :key="`energyDetails_${index}`"
            >
              <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="inverterId">
                  <b>Inverter ID:</b>
                  {{ " " }}
                  {{ singleEnergy.InverterId }}
                  <!-- {{ confirmEnergy( ).InverterId }} -->
                </div>

                <div
                  class="widget widget-alpha widget-alpha--color-amaranth"
                  style="flex-flow: column"
                >
                  <div class="col-sm-12 power_stat_">
                    <div
                      class="fa fa-bolt fa-4x text-left"
                      style="color: rgb(61, 177, 53)"
                    ></div>
                    <h3 class="stats-title">Generated Energy</h3>
                  </div>
                  <div class="row stat_data_row">
                    <div
                      class="col-sm-12 power_stat_row_"
                      style="font-size: 12px"
                    >
                      <div style="margin: 5px">
                        <div class="stats_header__title text-left">Today</div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).GeneratedToday || 0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div
                        v-if="parseFloat(MiscData.FV) < 1.76"
                        style="margin: 5px"
                      >
                        <div class="stats_header__title text-left">
                          This Week
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).GeneratedWeek || 0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div style="margin: 5px">
                        <div class="stats_header__title text-left">
                          This Month
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).GeneratedMonth || 0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div style="margin: 5px">
                        <div class="stats_header__title text-left">
                          This Year
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).GeneratedYear || 0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div
                        v-if="parseFloat(MiscData.FV) >= 1.76"
                        style="margin: 5px"
                      >
                        <div class="stats_header__title text-left">
                          All Time
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).GeneratedAllTime ||
                              0 * 1
                          }}kWh
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="parseFloat(MiscData.FV) >= 1.76 || MiscData.FV == 1.11"
                  class="widget widget-alpha widget-alpha--color-amaranth"
                  style="flex-flow: column"
                >
                  <div class="col-sm-12 power_stat_">
                    <div
                      class="fa fa-bolt fa-4x text-center"
                      style="color: rgb(232, 150, 0)"
                    ></div>
                    <h3 class="stats-title">Energy Consumed</h3>
                  </div>
                  <div class="row stat_data_row">
                    <div
                      class="col-sm-12 power_stat_row_"
                      style="font-size: 12px"
                    >
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">Today:</div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedToday || 0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div
                        v-if="parseFloat(MiscData.FV) < 1.76"
                        style="margin: 5px"
                      >
                        <div class="text-left stats_header__title">
                          This Week:
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedWeek || 0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">
                          This Month:
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedMonth || 0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">
                          This Year:
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedYear || 0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div
                        v-if="parseFloat(MiscData.FV) >= 1.76"
                        style="margin: 5px"
                      >
                        <div class="stats_header__title text-left">
                          All Time
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedAllTime ||
                              0 * 1
                          }}kWh
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="parseFloat(MiscData.FV) < 1.76"
                  class="widget widget-alpha widget-alpha--color-amaranth"
                  style="flex-flow: column"
                >
                  <div class="col-sm-12 power_stat_">
                    <div
                      class="fa fa-bolt fa-4x text-center"
                      style="color: rgb(232, 150, 0)"
                    ></div>
                    <h3 class="stats-title">Consumed Off Grid</h3>
                  </div>
                  <div class="row stat_data_row">
                    <div
                      class="col-sm-12 power_stat_row_"
                      style="font-size: 12px"
                    >
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">Today:</div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedTodayOffGrid ||
                              0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div
                        v-if="parseFloat(MiscData.FV) < 1.76"
                        style="margin: 5px"
                      >
                        <div class="text-left stats_header__title">
                          This Week:
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedWeekOffGrid ||
                              0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">
                          This Month:
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedMonthOffGrid ||
                              0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">
                          This Year:
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                              0 * 1
                          }}kWh
                        </div>
                      </div>
                      <div
                        v-if="parseFloat(MiscData.FV) >= 1.76"
                        style="margin: 5px"
                      >
                        <div class="stats_header__title text-left">
                          All Time
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                              0 * 1
                          }}kWh
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <can I="read" a="all">
                  <div
                    v-if="parseFloat(MiscData.FV) < 1.76 && MiscData.FV != 1.11"
                    class="widget widget-alpha widget-alpha--color-amaranth"
                    style="flex-flow: column"
                  >
                    <div class="col-sm-12 power_stat_">
                      <div
                        class="fa fa-bolt fa-4x text-center"
                        style="color: rgb(235, 59, 124)"
                      ></div>
                      <h3 class="stats-title">Energy Consumed On Grid</h3>
                    </div>
                    <div class="row stat_data_row">
                      <div
                        class="col-sm-12 power_stat_row_"
                        style="font-size: 12px"
                      >
                        <div style="margin: 5px">
                          <div class="text-left stats_header__title">
                            Today:
                          </div>
                          <div class>
                            {{
                              confirmEnergy(singleEnergy).ConsumedTodayOnGrid ||
                                0 * 1
                            }}kWh
                          </div>
                        </div>
                        <div
                          v-if="parseFloat(MiscData.FV) < 1.76"
                          style="margin: 5px"
                        >
                          <div class="text-left stats_header__title">
                            This Week:
                          </div>
                          <div class>
                            {{
                              confirmEnergy(singleEnergy).ConsumedWeekOnGrid ||
                                0 * 1
                            }}kWh
                          </div>
                        </div>
                        <div style="margin: 5px">
                          <div class="text-left stats_header__title">
                            This Month:
                          </div>
                          <div class>
                            {{
                              confirmEnergy(singleEnergy).ConsumedMonthOnGrid ||
                                0 * 1
                            }}kWh
                          </div>
                        </div>
                        <div style="margin: 5px">
                          <div class="text-left stats_header__title">
                            This Year:
                          </div>
                          <div class>
                            {{
                              confirmEnergy(singleEnergy).ConsumedYearOnGrid ||
                                0 * 1
                            }}kWh
                          </div>
                        </div>
                        <div
                          v-if="parseFloat(MiscData.FV) >= 1.76"
                          style="margin: 5px"
                        >
                          <div class="stats_header__title text-left">
                            All Time
                          </div>
                          <div class>
                            {{
                              confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                                0 * 1
                            }}kWh
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </can>

                <div
                  class="widget widget-alpha widget-alpha--color-amaranth"
                  style="flex-flow: column"
                >
                  <div class="col-sm-12 power_stat_">
                    <div
                      class="fa fa-bolt fa-4x text-center"
                      style="color: rgb(235, 59, 124); transform: rotate(20%)"
                    ></div>
                    <h3 class="stats-title text-center">
                      Peak Power Generated
                    </h3>
                  </div>
                  <div class="row stat_data_row">
                    <div
                      class="col-sm-12 power_stat_row_"
                      style="font-size: 12px"
                    >
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">Today:</div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).PeakToday || 0 * 1
                          }}kWp
                        </div>
                      </div>
                      <div
                        v-if="parseFloat(MiscData.FV) < 1.76"
                        style="margin: 5px"
                      >
                        <div class="text-left stats_header__title">
                          This Week:
                        </div>
                        <div class>
                          {{ confirmEnergy(singleEnergy).PeakWeek || 0 * 1 }}kWp
                        </div>
                      </div>
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">
                          This Month:
                        </div>
                        <div class>
                          {{
                            confirmEnergy(singleEnergy).PeakMonth || 0 * 1
                          }}kWp
                        </div>
                      </div>
                      <div style="margin: 5px">
                        <div class="text-left stats_header__title">
                          This Year:
                        </div>
                        <div class>
                          {{ confirmEnergy(singleEnergy).PeakYear || 0 * 1 }}kWp
                        </div>
                      </div>
                      <div
                        v-if="parseFloat(MiscData.FV) >= 1.76"
                        style="margin: 5px"
                      >
                        <div class="stats_header__title text-left">
                          All Time
                        </div>
                        <div class>
                          {{ confirmEnergy(singleEnergy).PeakYear || 0 * 1 }}kWp
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-card>
          </el-tab-pane>
          <el-tab-pane
            label="Battery"
            style="padding-top: 20px; padding-bottom: 20px"
          >
            <Center class="row" style="padding: 8px">
              <!-- <span class="fa fa-bolt"></span> -->
              <battery
                :width="`300px`"
                :height="`150px`"
                :direction="`x`"
                :level="Device.BatteryData && Device.BatteryData.SOC"
              ></battery>
            </Center>
            <hr />
            <Center class="row" style="padding: 8px">
              <h1>
                {{
                  roundUp(
                    ((Device.BatteryData && Device.BatteryData.SOC) || 0) * 1
                  )
                }}% &dash;
                <small
                  >{{
                    Device.BatteryData && Device.BatteryData.TotalBatCur
                  }}A</small
                >
              </h1>
              <small>
                Charge cycles:
                {{ Device.MiscData && Device.MiscData.ChgCycle }}/{{
                  Device.MiscData && Device.MiscData.ExptdChgCyl
                }}
              </small>
              <p>{{ batteryMode(Device.Mode) }}</p>
              <Can I="manage" a="installation">
                <span>{{ batteryLife }}</span>
              </Can>
            </Center>
            <hr />

            <div
              class="inverterInfo"
              v-for="(dataKey, index) in Object.keys(Device.BatteryData)"
              v-show="dataKey != 'InverterId'"
              :key="`BatteryData${index}`"
            >
              <b>{{ getLabel(dataKey) }}</b>
              <span>
                {{
                  Device.BatteryData[dataKey] == 1
                    ? "Yes"
                    : Device.BatteryData[dataKey] == 0
                    ? "No"
                    : getDisplayValue(Device.BatteryData, dataKey)
                }}
              </span>
            </div>

            <!-- {{Device}} -->
            <!-- {{Device.MiscData}} -->
          </el-tab-pane>
          <el-tab-pane
            label="Misc Data"
            style="padding-top: 20px; padding-bottom: 20px"
          >
            <h3>System Info</h3>
            <!-- {{Device.MiscData}} -->
            <hr />
            <div
              class="inverterInfo"
              v-for="(dataKeyMisc, index) in Object.keys(Device.MiscData)"
              v-show="dataKeyMisc != 'InverterId'"
              :key="`MiscData${index}`"
            >
              <b>{{ getLabel(dataKeyMisc) }}</b>
              <span>{{ getDisplayValue(Device.MiscData, dataKeyMisc) }}</span>
              <!-- <span>{{Device.MiscData[dataKeyMisc] +getUnit(Device.MiscData[dataKeyMisc],dataKeyMisc)}}</span> -->
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </vk-offcanvas>

    <div v-if="initError" class="sadFaceIOT">
      <i class="fa fa-meh-o fa-3x" style="font-size: 20rem"></i>
      <h1>Device not smart yet!!!</h1>
      <h3>check back later...</h3>
    </div>
    <div v-else class="col-md-12" style="position: relative">
      <!-- <h3>I am here!!</h3> -->
      <!-- system overview Begin -->
      <div
        style="
          display: flex;
          padding: 10px !important;
          flex-flow: row;
          justify-content: center;
          top: 0px;
        "
      >
        <div
          class="widget widget-alpha widget-alpha--color-amaranth"
          style="flex-flow: row; display: flex; flex: 1"
        >
          <div class="stats" style="align-items: left; padding: 10px">
            <h1 style="margin-top: 20px">
              <img src="@/assets/img/avatar.png" alt class="_user-avatar" />
              {{ installationData.name || "-" }}
            </h1>
            <!-- hey {{ installationType }} -->

            <b style="font-size: 17px"
              >Last Seen: {{ lastSeen(Device.Timestamp) }}</b
            >
            <p>
              Installed Capacity:
              {{ installationCapacity }} ( <span>{{ installationType }}</span
              >)
            </p>
          </div>
          <div class="stats" style="align-items: left; padding: 10px">
            <span
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <can I="manage" a="installation">
                <button
                  class="btn btn-danger"
                  v-if="statusCalc(Device.Timestamp)"
                  @click="triggerRemoveDeviceOnPerformanceList"
                >
                  Remove
                </button>
                &nbsp;
              </can>
              <button
                class="btn btn-warning"
                v-if="alarmFlags.warning == true"
                @click="showAlarm('warnings')"
              >
                Warning
              </button>
              &nbsp;
              <button
                class="btn btn-danger"
                v-if="alarmFlags.error == true"
                @click="showAlarm('errors')"
              >
                Fault
              </button>
              &nbsp;
              <button @click="showOffCanvas = true" class="btn btn-primary">
                System Details
              </button>
              <el-button
                type="success"
                style="margin-left: 10px"
                @click="exportData"
                :disabled="viewDataLoading"
                plain
                >{{
                  exportDataLoading ? "Downloading..." : "Download Report"
                }}</el-button
              >
            </span>
            <div>{{ batteryLife }}</div>
          </div>
        </div>
      </div>
      <div v-if="screenView.code === 0">
        <!-- <div class="row">
        <div class="col-md-4 col-sm-6 col-xs-12 mb-5">
          <el-card class="box-card widget">
            <div
              slot="header"
              class="widget_header"
              style="display: flex; justify-content: space-between;"
            >
              <span class="widget_header__title" style="flex: 1;">Consumption</span>
            </div>
            <grey-chart
              :type="`line`"
              :data="solarchartdata"
              :id="`solarchartdata`"
              ref="solarchartdata"
            ></grey-chart>
          </el-card>
        </div>
        </div>-->
        <!-- <div class="row">  -->

        <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
          <!-- {{Device.InstallType}} -->

          <div class="row" style="margin-bottom: 12px">
            <div class="col-md-12">
              <el-collapse class v-model="activeNames">
                <el-collapse-item title="Monitor" name="1">
                  <system-monitor
                    :isDeviceOffline="statusCalc(Device.TimeStamp)"
                    :device="Device"
                  />
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <div class="row" style="margin-bottom: 12px">
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                style="height: 90%"
              >
                <div class="top-widget-box performance">
                  <div class="top-widget-box__header">
                    <i class="fa fa-calendar fa-4x icon"></i>
                  </div>
                  <div class="top-widget-box__body">
                    <!-- {{JSON.stringify(EnergyData)}} -->
                    <span class="stats_header__title">
                      Device
                      {{ statusCalc(Device.Timestamp) ? "Offline" : "Online" }}
                    </span>
                    <h1>{{ batteryMode(Device.Mode) }}</h1>
                    <p class="top-subtitle">&nbsp;</p>
                    <p class="stats_header__title">
                      {{ lastSeen(Device.Timestamp) }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                style="height: 90%"
              >
                <div class="top-widget-box performance">
                  <div class="top-widget-box__header">
                    <i class="fa fa-bolt fa-4x icon"></i>
                  </div>
                  <div class="top-widget-box__body">
                    <span class="stats_header__title">Load Wattage</span>
                    <h1>{{ activePower(Device.InvAggrData) }} kW</h1>
                    <p class="top-subtitle">&nbsp;</p>
                    <p class="stats_header__title">
                      {{ activePercent(Device.InvAggrData) }}% Load
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                style="height: 90%"
              >
                <div class="top-widget-box performance">
                  <div class="top-widget-box__header">
                    <battery
                      :width="`60px`"
                      :height="`40px`"
                      :direction="`y`"
                      :level="Device.BatteryData && Device.BatteryData.SOC"
                    ></battery>
                  </div>
                  <div class="top-widget-box__body">
                    <span class="stats_header__title"
                      >Battery
                      {{
                        Device.BatteryData && Device.BatteryData.CurrentState
                      }}</span
                    >
                    <h1>
                      {{ Device.BatteryData && Device.BatteryData.SOC * 1 }}%
                      &dash;
                      <small
                        >{{
                          Device.BatteryData && Device.BatteryData.TotalBatCur
                        }}A</small
                      >
                    </h1>
                    <p class="top-subtitle">
                      {{
                        Device.BatteryData && Device.BatteryData.CurrentState
                      }}
                    </p>
                    <!-- <small
                      class="top-subtitle"
                    >Charge cycles: {{ Device.MiscData.ChgCycle }}/{{ Device.MiscData.ExptdChgCyl }}</small>-->
                    <p class="stats_header__title">
                      PV Power:
                      {{
                        Device.InverterData
                          ? panelPowerReduce(Device.InverterData)
                          : "-"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6">
              <div
                class="widget widget-alpha widget-alpha--color-amaranth"
                :style="{
                  'background-color':
                    parseFloat(MiscData.GridPower) > 0
                      ? '#2ED47A !important'
                      : '#e74c3c !important',
                  height: '100%'
                }"
              >
                <div class="top-widget-box performance">
                  <div class="top-widget-box__header">
                    <i
                      class="fa fa-lightbulb-o fa-4x icon"
                      aria-hidden="true"
                      style="color: #fff"
                    ></i>
                  </div>
                  <div class="top-widget-box__body">
                    <span class="stats_header__title" style="color: #fff"
                      >Grid Status</span
                    >
                    <h1 style="color: #fff">
                      {{ parseFloat(MiscData.GridPower) > 0 ? "ON" : "OFF" }}
                    </h1>
                    <p class="top-subtitle">&nbsp;</p>
                    <p class="stats_header__title">&nbsp;</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Statistcis -->
        <!-- {{JSON.stringify(MiscData)}} -->
        <div class="col-md-12 col-sm-12 col-xs-12">
          <div
            class="widget widget-alpha widget-alpha--color-amaranth"
            style="flex-flow: column"
          >
            <div class="row stat_data_row">
              <div class="col-sm-4 power_stat_">
                <div
                  class="fa fa-bolt fa-4x text-center"
                  style="color: rgb(61, 177, 53)"
                ></div>
                <h3 class="stats-title">Generated Energy</h3>
              </div>
              <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                <div style="margin: 5px">
                  <div class="stats_header__title text-left">Today</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).GeneratedToday || 0 * 1 }}kWh
                  </div>
                </div>
                <div
                  v-if="parseFloat(MiscData.FV) < 1.76 && MiscData.FV != 1.11"
                  style="margin: 5px"
                >
                  <div class="stats_header__title text-left">This Week</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).GeneratedWeek || 0 * 1 }}kWh
                  </div>
                </div>
                <div style="margin: 5px">
                  <div class="stats_header__title text-left">This Month</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).GeneratedMonth || 0 * 1 }}kWh
                  </div>
                </div>
                <div style="margin: 5px">
                  <div class="stats_header__title text-left">This Year</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).GeneratedYear || 0 * 1 }}kWh
                  </div>
                </div>
                <div v-if="parseFloat(MiscData.FV) >= 1.76" style="margin: 5px">
                  <div class="stats_header__title text-left">All Time</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).GeneratedAllTime || 0 * 1 }}kWh
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="parseFloat(MiscData.FV) >= 1.76 || MiscData.FV == 1.11"
            class="widget widget-alpha widget-alpha--color-amaranth"
            style="flex-flow: column"
          >
            <div class="row stat_data_row">
              <div class="col-sm-4 power_stat_">
                <div
                  class="fa fa-bolt fa-4x text-center"
                  style="color: rgb(232, 150, 0)"
                ></div>
                <h3 class="stats-title">Energy Consumed</h3>
              </div>
              <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">Today:</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).ConsumedToday || 0 * 1 }}kWh
                  </div>
                </div>
                <div
                  v-if="parseFloat(MiscData.FV) < 1.76 && MiscData.FV != 1.11"
                  style="margin: 5px"
                >
                  <div class="text-left stats_header__title">This Week:</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).ConsumedWeek || 0 * 1 }}kWh
                  </div>
                </div>
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">This Month:</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).ConsumedMonth || 0 * 1 }}kWh
                  </div>
                </div>
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">This Year:</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).ConsumedYear || 0 * 1 }}kWh
                  </div>
                </div>
                <div v-if="parseFloat(MiscData.FV) >= 1.76" style="margin: 5px">
                  <div class="stats_header__title text-left">All Time</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).ConsumedAllTime || 0 * 1 }}kWh
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="parseFloat(MiscData.FV) < 1.76 && MiscData.FV != 1.11"
            class="widget widget-alpha widget-alpha--color-amaranth"
            style="flex-flow: column"
          >
            <div class="row stat_data_row">
              <div class="col-sm-4 power_stat_">
                <div
                  class="fa fa-bolt fa-4x text-center"
                  style="color: rgb(232, 150, 0)"
                ></div>
                <h3 class="stats-title">Consumed Off Grid</h3>
              </div>
              <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">Today:</div>
                  <div class>
                    {{
                      confirmEnergy(EnergyData).ConsumedTodayOffGrid || 0 * 1
                    }}kWh
                  </div>
                </div>
                <div
                  v-if="parseFloat(MiscData.FV) < 1.76 && MiscData.FV != 1.11"
                  style="margin: 5px"
                >
                  <div class="text-left stats_header__title">This Week:</div>
                  <div class>
                    {{
                      confirmEnergy(EnergyData).ConsumedWeekOffGrid || 0 * 1
                    }}kWh
                  </div>
                </div>
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">This Month:</div>
                  <div class>
                    {{
                      confirmEnergy(EnergyData).ConsumedMonthOffGrid || 0 * 1
                    }}kWh
                  </div>
                </div>
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">This Year:</div>
                  <div class>
                    {{
                      confirmEnergy(EnergyData).ConsumedYearOffGrid || 0 * 1
                    }}kWh
                  </div>
                </div>
                <div v-if="parseFloat(MiscData.FV) >= 1.76" style="margin: 5px">
                  <div class="stats_header__title text-left">All Time</div>
                  <div class>
                    {{
                      confirmEnergy(EnergyData).ConsumedYearOffGrid || 0 * 1
                    }}kWh
                  </div>
                </div>
              </div>
            </div>
          </div>

          <can I="read" a="all">
            <div
              v-if="parseFloat(MiscData.FV) < 1.76 && MiscData.FV != 1.11"
              class="widget widget-alpha widget-alpha--color-amaranth"
              style="flex-flow: column"
            >
              <div class="row stat_data_row">
                <div class="col-sm-4 power_stat_">
                  <div
                    class="fa fa-bolt fa-4x text-center"
                    style="color: rgb(235, 59, 124)"
                  ></div>
                  <h3 class="stats-title">Energy Consumed On Grid</h3>
                </div>
                <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">Today:</div>
                    <div class>
                      {{
                        confirmEnergy(EnergyData).ConsumedTodayOnGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div
                    v-if="parseFloat(MiscData.FV) < 1.76 && MiscData.FV != 1.11"
                    style="margin: 5px"
                  >
                    <div class="text-left stats_header__title">This Week:</div>
                    <div class>
                      {{
                        confirmEnergy(EnergyData).ConsumedWeekOnGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">This Month:</div>
                    <div class>
                      {{
                        confirmEnergy(EnergyData).ConsumedMonthOnGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div style="margin: 5px">
                    <div class="text-left stats_header__title">This Year:</div>
                    <div class>
                      {{
                        confirmEnergy(EnergyData).ConsumedYearOnGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                  <div
                    v-if="parseFloat(MiscData.FV) >= 1.76"
                    style="margin: 5px"
                  >
                    <div class="stats_header__title text-left">All Time</div>
                    <div class>
                      {{
                        confirmEnergy(EnergyData).ConsumedYearOffGrid || 0 * 1
                      }}kWh
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </can>

          <div
            class="widget widget-alpha widget-alpha--color-amaranth"
            style="flex-flow: column"
          >
            <div class="row stat_data_row">
              <div class="col-sm-4 power_stat_">
                <div
                  class="fa fa-bolt fa-4x text-center"
                  style="color: rgb(235, 59, 124); transform: rotate(20%)"
                ></div>
                <h3 class="stats-title text-center">Peak Power Generated</h3>
              </div>
              <div class="col-sm-8 power_stat_row_" style="font-size: 12px">
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">Today:</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).PeakToday || 0 * 1 }}kWp
                  </div>
                </div>
                <div
                  v-if="parseFloat(MiscData.FV) < 1.76 && MiscData.FV != 1.11"
                  style="margin: 5px"
                >
                  <div class="text-left stats_header__title">This Week:</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).PeakWeek || 0 * 1 }}kWp
                  </div>
                </div>
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">This Month:</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).PeakMonth || 0 * 1 }}kWp
                  </div>
                </div>
                <div style="margin: 5px">
                  <div class="text-left stats_header__title">This Year:</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).PeakYear || 0 * 1 }}kWp
                  </div>
                </div>
                <div v-if="parseFloat(MiscData.FV) >= 1.76" style="margin: 5px">
                  <div class="stats_header__title text-left">All Time</div>
                  <div class>
                    {{ confirmEnergy(EnergyData).PeakYear || 0 * 1 }}kWp
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Statistics -->
      </div>
      <!-- system overview end-->

      <!-- Chaart Begin -->
      <el-card v-if="screenView.code === 1" class="box-card widget">
        <div class="col-md-12 col-sm-12 col-xs-12 mb-5">
          <!-- <device-charts :inverterId="inverterId"></device-charts> -->
          <!-- <div class="block" align="left" style="margin-bottom:25px">
             <el-date-picker
              v-model="filterDate"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="-"
              start-placeholder="Start date"
              end-placeholder="End date"
              align="center"
            ></el-date-picker>
            <el-button type="warning" @click="filterChart" plain>Filter</el-button>
            <el-button style="margin-left:40%" type="primary" @click="exportData" plain>Export Data</el-button>
            <el-button
              type="success"
              @click="exportDataToTable"
              :disabled="viewDataLoading"
              plain
            >{{viewDataLoading?"Loading...":"View Data History"}}</el-button>
            <el-button
              @click="getDeviceWarningsMapper"
              type="warning"
              plain
              :disabled="warningDataLoading"
            >{{warningDataLoading?"Loading...":"Warning/Alarm History"}}</el-button>
          </div>
            <div v-loading="loading" class="col-md-6 col-sm-6 col-xs-12">
            <grey-chart
              :short="true"
              :type="charttype"
              :options="chartGenOption"
              :data="solarGenchartdata"
              :id="`solarGenchartdata`"
              ref="solarGenchartdata"
            ></grey-chart>
        </div>
          <div v-loading="loading" class="col-md-6 col-sm-6 col-xs-12">
           <grey-chart
              :short="true"
              :type="charttype"
              :options="chartConsumpOption"
              :data="solarConsumpchartdata"
              :id="`solarConsumpchartdata`"
              ref="solarConsumpchartdata"
            ></grey-chart>
          </div>-->
        </div>
      </el-card>
      <!-- Chart end -->
      <!-- </div> -->
      <!-- Device Control begin -->
      <div
        v-if="screenView.code === 2"
        class="box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"
      >
        <device-control :inverterId="inverterId"></device-control>
      </div>
      <!-- Device Control End -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import {
  Carousel,
  CarouselItem,
  Breadcrumb,
  BreadcrumbItem,
  Loading,
  DatePicker,
  Notification
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import GreyChart from "@/components/pages/kitchen/grey-chart";
import InstallationStat from "../installationStat";
import dummyData from "../dummy.json";
import Battery from "@/components/pages/kitchen/grey-battery";
import moment from "moment";
import { HTTP as IOTHTTP } from "@/store/actions";
import DeviceCharts from "../widgets/charts";
// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";
import { mapGetters, mapActions } from "vuex";
import payloadDictionary from "../payload_dictionary.json";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)

import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
var flatten = require("flat");
// var converter = require("json-2-csv");

import DeviceControl from "../widgets/controls";
Vue.use(Breadcrumb);
Vue.use(DatePicker);
Vue.use(Loading);
Vue.use(BreadcrumbItem);

import SystemMonitor from "@/components/pages/dashboard/animated-icons";
import helpers from "@/components/utils/helpers.js";

export default {
  name: "deviceDetails",
  mixins: [helpers],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat,
    GreyChart,
    Battery,
    datetime: Datetime,
    "vk-offcanvas": Offcanvas,
    "vk-offcanvas-close": OffcanvasClose,
    "device-control": DeviceControl,
    "device-charts": DeviceCharts,
    "system-monitor": SystemMonitor
    // powerStat,
    // flatPickr,
  },
  computed: {
    ...mapGetters(["DeviceList", "graphDeviceDetails"]),
    rows() {
      return this.exportDataToTableValues.length;
    },

    batteryLife: {
      get() {
        try {
          let DOD = 10;
          let totalBatteryCapacity = 5400; //Wh

          let { BatteryData, InverterData } = this.Device;
          let SOC = parseFloat(BatteryData && BatteryData.SOC);
          let dcop = parseInt(
            InverterData &&
              InverterData.length > 0 &&
              InverterData[0]["DCOutputPower"]
          );
          console.log({ dcop });
          if (dcop) {
            console.log({ SOC, dcop });
            // -- Firstly we estimate Battery remaining capacity
            let batteryRemainingCapacity =
              ((SOC - DOD) / 100) * totalBatteryCapacity;
            // console.log({ batteryRemainingCapacity });

            // --- Secondly, we calculate battery hours left
            let batteryHoursLeft = batteryRemainingCapacity / dcop; //w;

            // console.log({ batteryHoursLeft });

            // --- We can then calculate Battery minutes left

            let batteryMinutesLeft = batteryHoursLeft * 60;
            let m = (batteryHoursLeft % 1) * 60;

            console.log({
              batteryHoursLeftSplit: batteryHoursLeft % 1,
              batteryHoursLeftFixed: Math.floor(batteryHoursLeft),
              minuites: Math.floor(m)
            });

            // console.log({ batteryMinutesLeft });
            // console.log({ device: this.Device });
            return `${Math.floor(batteryHoursLeft)} hours, ${Math.floor(
              m
            )} minutes`;
          } else return ``;
        } catch (error) {
          console.log("error", error);
        }
      }
    },
    installationType: {
      get() {
        try {
          let { name, deviceType } = this.installationData;
          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              return deviceType.name;
            } else {
              return `Arnergy ${
                this.Device.MiscData ? this.Device.MiscData.InstallSize : ""
              } kVA`;
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError });
        }
      }
    },
    installationCapacity: {
      get() {
        try {
          let { name, deviceType } = this.installationData;
          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              // console.log({ hey: deviceType.name.split(" ")[1].split("-") });
              let configVal = deviceType.name.split(" ")[1].split("-")[0];
              // console.log({ configVal });
              return configVal;
            } else {
              return `${
                this.Device.MiscData ? this.Device.MiscData.InstallSize : ""
              } kVA`;
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError });
        }
      }
    },
    warningRows() {
      return this.warningsData.length;
    },
    statusBorder: {
      get() {
        return this.statusCalc(this.Device.Timestamp) == true
          ? "4px solid #e34a4a;"
          : "4px solid #1893CA;";
      },
      set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  },
  data: function() {
    return {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      Device: {
        BatteryData: {}
      },
      singularEnergyData: [],
      MiscData: {},
      inverter: null,
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      warningDataLoading: false,
      viewDataLoading: false,
      exportDataLoading: false,
      installationData: { name: "Loading..." },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningsData: [],
      warningsDataValuesFields: [],
      perPage: 10,
      currentPage: 1,
      warningCurrentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: [
        "payload.InverterDetected",
        "payload.Version",
        "payload.DeviceID",
        "payload.BatteryData.SOC",
        "payload.Timestamp"
      ],
      warningsDataTableoptions: [],
      warningsDataValuesFields: [
        "DeviceTimeStamp",
        "InverterId",
        "InverterOverCurrent",
        "InverterVoltageTooHigh"
      ],
      exportDataTableoptions: [
        {
          value: "Option1",
          label: "Option1"
        },
        {
          value: "Option2",
          label: "Option2"
        },
        {
          value: "Option3",
          label: "Option3"
        },
        {
          value: "Option4",
          label: "Option4"
        },
        {
          value: "Option5",
          label: "Option5"
        }
      ],
      value1: [],
      // [00, 01, 02] (utility first, solar first, solar and utility)
      filterDate: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      chargerPriorityList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Utility First",
          value: "00"
        },
        {
          text: "Solar First",
          value: "01"
        },
        {
          text: "Solar and Utility",
          value: "02"
        }
      ],
      outputPriority: "01",
      outputPriorityList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Utility First",
          value: "00"
        },
        {
          text: "Solar First",
          value: "01"
        },
        {
          text: "SBU First",
          value: "02"
        }
      ],
      deviceMode: "00",
      deviceModeList: [
        {
          text: "Select Option",
          value: null,
          disabled: true
        },
        {
          text: "Inverter Mode",
          value: "00"
        },
        {
          text: "UPS Mode",
          value: "01"
        }
      ],
      show: true,
      Device: {},
      // IOTSRC: "https://arnergy-dash-api.herokuapp.com",
      IOTSRC: "http://arnergy-dash-api.herokuapp.com",
      expiryToSend: "",
      THIS_WEEK: moment()
        .startOf("week")
        .toDate(),
      THIS_MONTH: moment()
        .startOf("month")
        .toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartGenOption: {
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "PV Charging Power (KW)"
              }
            }
          ]
        }
      },
      chartConsumpOption: {
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Battery Percentage (%)"
                //labelString: "AC Output Active Power (KW)"
              }
            }
          ]
        }
      },
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [
          {
            label: "Loading",
            data: [],
            backgroundColor: "rgba(255, 99, 132, 0.3)",
            borderWidth: 1
          }
        ]
      },
      solarGenchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [
          {
            label: "Loading",
            data: [],
            backgroundColor: "rgba(255, 99, 132, 0.3)",
            borderWidth: 1
          }
        ]
      },
      solarConsumpchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [
          {
            label: "Loading",
            data: [],
            backgroundColor: "rgba(255, 99, 132, 0.3)",
            //backgroundColor: fillPattern,
            borderWidth: 1
          }
        ]
      },
      timeRightNow: moment(),
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      HealthData: [],
      warnings: [],
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        errors: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },

        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating",
          Overload: "System Overload"
        }
      }
    };
  },
  methods: {
    ...mapActions(["refreshList", "setDeviceCurrentSettings"]),
    triggerRemoveDeviceOnPerformanceList() {
      let response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        let params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        IOTHTTP.post(`/devicedata/delete`, params, {
          headers
        })
          .then(resp => {
            alert("Successfully removed");
            this.$router.go(-1);

            // this.$router.go(-1);
          })
          .catch(err => {
            alert("An error uccured please try agin");
            console.log(err);
          });
      }
    },
    panelPowerReduce(InverterData, version = "v3") {
      try {
        var power = InverterData.reduce((acc, parameter) => {
          let powerKey = `PVChargingPower${version == "v4" ? "1" : ""}`;
          // console.log({ powerKey }, Object.keys(parameter));
          return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
        }, 0);
        return power / 1000 + "kW";
      } catch (error) {
        console.log(error);
      }
    },
    panelPowerReduceRaw(InverterData, version = "v3") {
      // console.log({ InverterData });

      var power = InverterData
        ? InverterData.reduce((acc, parameter) => {
            let powerKey = `PVChargingPower${version == "v4" ? "1" : ""}`;
            return parameter[powerKey]
              ? acc + parameter[powerKey] * 1
              : acc + 0;
          }, 0)
        : "";
      return power;
    },
    getLabel(key) {
      // console.log(key);
      return payloadDictionary.find(x => x.new_key == key || x.old_key == key)
        ? payloadDictionary.find(x => x.new_key == key || x.old_key == key)[
            "label"
          ]
        : key;
    },
    getUnit(displayedData, key) {
      let unit = payloadDictionary.find(
        x => x.new_key == key || x.old_key == key
      )
        ? payloadDictionary.find(x => x.new_key == key || x.old_key == key)[
            "unit"
          ]
        : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue(singleInverter, key) {
      let displayedData = singleInverter[key];

      let config = payloadDictionary.find(
        x => x.new_key == key || x.old_key == key
      );
      let unit = config ? config["unit"] : "";
      let dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType ,key});
      // console.log({singleInverter,key,config});
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          let tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          let tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }

      if (
        dataType == "Integer" ||
        dataType == "Float" ||
        dataType == "String"
      ) {
        try {
          let tmpDisplayData = Number(displayedData);
          return !isNaN(tmpDisplayData) ? tmpDisplayData + unit : displayedData;
        } catch (error) {}
      }
      return displayedData;

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    exportData() {
      this.exportDataloading = true;
      this.filterDate
        ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000)
        : this.DataToExport();
    },

    getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate
        ? this.getDeviceWarningsObject(
            this.filterDate[0],
            this.filterDate[1],
            1000
          )
        : this.getDeviceWarningsObject();
    },
    exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate
        ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000)
        : this.DataToExportToTable();
    },
    filterChart() {
      this.loading = true;
      this.filterDate
        ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000)
        : this.getDeviceData();
    },
    async getDeviceWarningsObject(
      upperLimit = null,
      lowerLimit = null,
      limit = 100
    ) {
      let app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Warnings",
        KeyConditionExpression:
          "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":up":
            upperLimit ||
            moment("2019/6/20")
              .startOf("day")
              .toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      IOTHTTP.post(`/devicedata`, data, {
        headers
      })
        .then(resp => {
          this.warningDataLoading = false;
          this.warningsOffCanvas = true;
          let _tmp = resp.data.Items.map(x => {
            let data = this.transformListData(x.payload.WarningsData);
            data.DeviceTimeStamp = x.DeviceTimeStamp;
            return data;
          });
          let warningsData = [];
          _tmp.map(v => {
            return v.map(v1 => {
              v1.DeviceTimeStamp = v.DeviceTimeStamp;
              warningsData.push(v1);
            });
          });

          let transformed = [];
          const yes = "YES";
          const no = "NO";
          warningsData.map(v => {
            let tmp = {};
            tmp.InverterId = v.InverterId;
            tmp.DeviceTimeStamp = v.DeviceTimeStamp;
            tmp.BatteryDerating = v.BatteryDerating === "0" ? no : yes;
            tmp.BatteryLowAlarm = v.BatteryLowAlarm === "0" ? no : yes;
            tmp.BatteryOpen = v.BatteryOpen === "0" ? no : yes;
            tmp.BatteryUnderShutdown =
              v.BatteryUnderShutdown === "0" ? no : yes;
            tmp.BatteryVoltageHigh = v.BatteryVoltageHigh === "0" ? no : yes;
            tmp.BusOver = v.BusOver === "0" ? no : yes;
            tmp.BusSoftFail = v.BusSoftFail === "0" ? no : yes;
            tmp.BusUnder = v.BusUnder === "0" ? no : yes;
            tmp.CurrentSensorFail = v.CurrentSensorFail === "0" ? no : yes;
            tmp.EepromFault = v.EepromFault === "0" ? no : yes;
            tmp.FanLocked = v.FanLocked === "0" ? no : yes;
            tmp.InverterFault = v.InverterFault === "0" ? no : yes;
            tmp.InverterOverCurrent = v.InverterOverCurrent === "0" ? no : yes;
            tmp.InverterVoltageTooHigh =
              v.InverterVoltageTooHigh === "0" ? no : yes;
            tmp.InverterVoltageTooLow =
              v.InverterVoltageTooLow === "0" ? no : yes;
            tmp.IvSfFl = v.IvSfFl === "0" ? no : yes;
            tmp.LineFail = v.LineFail === "0" ? no : yes;
            tmp.OPDCVoltageOpen = v.OPDCVoltageOpen === "0" ? no : yes;
            tmp.OPVShort = v.OPVShort === "0" ? no : yes;
            tmp.OverTemperature = v.OverTemperature === "0" ? no : yes;
            tmp.Ovld = v.Ovld === "0" ? no : yes;
            tmp.Reserved01 = v.Reserved01 === "0" ? no : yes;
            tmp.Reserved02 = v.Reserved02 === "0" ? no : yes;
            tmp.Reserved03 = v.Reserved03 === "0" ? no : yes;
            tmp.Reserved04 = v.Reserved04 === "0" ? no : yes;
            tmp.SelfTestFail = v.SelfTestFail === "0" ? no : yes;
            transformed.push(tmp);
          });
          this.warningsData = transformed;
          console.log(this.warningsData);
          this.warningsDataTableoptions = Object.keys(warningsData[0]);
        })
        .catch(err => {
          console.log(JSON.stringify(err));
        });
    },
    showAlarm(type) {
      var excluded = [
        "id",
        "deviceID",
        "InverterId",
        "Timestamp",
        "updatedAt",
        "lineFail"
      ];
      let resp = Object.keys(this.flags[type]).reduce((_tmp, _curr) => {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return (_tmp +=
          this.Device.Warnings[_curr] * 1 > 0
            ? `<li>${this.flags[type][_curr]}</li>`
            : "");
      }, "");
      if (type == "warnings") {
        Notification.warning({
          title: `${type[0].toUpperCase()}${type.slice(1)}`,
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        Notification.error({
          title: `${type[0].toUpperCase()}${type.slice(1)}`,
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = [
          "id",
          "deviceID",
          "InverterId",
          "Timestamp",
          "updatedAt",
          "lineFail"
        ],
        tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (
          Payload.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0
        ) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    datePickerTrigger() {
      this.show = true;
    },
    formatDate(_date) {
      // return _date;
      return moment(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen(Time) {
      // console.log(this.Device)
      return moment(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },
    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc(date) {
      var difference = Math.abs(moment(this.timeRightNow).diff(moment(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel(date) {
      var difference = Math.abs(moment().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg =
          "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg =
          "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg =
          "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json(data) {
      return JSON.parse(data);
    },
    loadSum() {
      try {
        device.payload.InverterData.reduce((acc, obj) => {
          return (acc += Number(obj["OL%"]));
        }, 0);
      } catch (error) {
        console.log("loadSum", error);
      }
    },
    countFlags(Warning, type) {
      var excluded = [
        "id",
        "deviceID",
        "InverterId",
        "DeviceTimeStamp",
        "createdAt",
        "updatedAt"
      ];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (
          Warning.hasOwnProperty(property) &&
          excluded.indexOf(property) < 0 &&
          search.hasOwnProperty(property)
        ) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return true;
      } else {
        return false;
      }
    },
    getExtraSourceWhileOnBattery(
      batteryMode,
      OutputLoadNotPercent,
      solarPower
    ) {
      // console.log({ batteryMode, OutputLoadNotPercent, solarPower });

      if (batteryMode === "On Battery") {
        if (solarPower > OutputLoadNotPercent) {
          return "On Solar";
        } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
          return "On Solar & Battery";
        } else return batteryMode;
      } else return batteryMode;
    },
    roundUpHandler(num) {
      return Math.round(num * 100) / 100;
    },
    batteryMode(mode) {
      try {
        let resp = "Battery Mode";
        switch (mode) {
          case "P":
            resp = "Power On";
            break;
          case "S":
            resp = "On Standby";
            break;
          case "L":
            resp = "On Grid";
            break;
          case "B":
            resp = "On Battery";
            break;
          case "F":
            resp = "Fault";
            break;
          case "H":
            resp = "Power saving mode";
            break;
          case "C":
            resp = "Charging";
            break;
          default:
        }

        let outputLoad = this.Device.InverterData.reduce((acc, obj) => {
          // console.log({ obj });

          return (acc += Number(obj["ACOutputApparentPower"]));
        }, 0);
        outputLoad = this.roundUpHandler(outputLoad);
        let solarPower = this.panelPowerReduceRaw(this.Device.InverterData);
        resp = this.getExtraSourceWhileOnBattery(resp, outputLoad, solarPower);

        // console.log({ resp, outputLoad, solarPower, mode });

        return resp || "Battery Mode";
      } catch (error) {
        console.log("batteryMode", error);
      }
    },
    renderChart() {
      this.$refs.solarConsumpchartdata.reload(
        this.solarConsumpchartdata,
        this.charttype,
        this.chartConsumpOption
      );
      this.$refs.solarGenchartdata.reload(
        this.solarGenchartdata,
        this.charttype,
        this.chartGenOption
      );
    },
    timeAgo(date) {
      var difference = moment(date).fromNow();
      return difference;
    },
    activePower(InvAggrData) {
      try {
        // console.log({ InvAggrData });
        if (InvAggrData) {
          return (InvAggrData.AACOAP * 1) / 1000;
        }
        let { InverterData } = this.Device;
        var power = InverterData.reduce((acc, parameter) => {
          let lw =
            parameter["ACOutputApparentPower"] || parameter["DCOutputPower"];
          return acc + lw * 1;
        }, 0);
        let ac = power / 1000;

        return ac || 0;
      } catch (error) {}
    },
    activePercent(InvAggrData) {
      if (InvAggrData) {
        return InvAggrData["AOL%"];
      }
      let { InverterData } = this.Device;
      console.log({ InverterData });

      var power = InverterData.reduce((acc, parameter) => {
        return acc + parameter["OutputLoadPercent"] * 1;
      }, 0);
      let ap = power / InverterData.length;
      return this.roundUp(ap || 0);
    },
    panelPower(parameters) {
      var power = this.roundUp(
        (parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1)) / 1000
      );
      return power + " kW";
    },
    powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl() {
      this.$refs.controlModal.hide();
    },
    control() {
      const HTTP = this.$httpUtils.instance;
      var inverterId = `${this.inverterId}`;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = `${this.$utilConstants.IOT_BASE_URL}/event/publish/`;
      // console.log(endies + path + '/' + inverterId)
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = JSON.stringify({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = JSON.stringify({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.chargerPriority}`
          });
          break;
        case "output-priority":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.outputPriority}`
          });
          break;
        case "device-mode":
          requestParam.payload = JSON.stringify({
            command: `${param.toUpperCase()}${this.deviceMode}`
          });
          break;
        case "ssh":
          requestParam =
            "ipaddress=" +
            this.ipAddress +
            "&username=" +
            this.username +
            "&password=" +
            this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = JSON.stringify({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam)
        .then(response => {
          alert("Sent!!!");
          this.hideControl();
        })
        .catch(e => {
          //  console.log(e);
        });
    },
    confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth(type) {
      const container = this;
      const HTTP = this.$httpUtils.instance;
      HTTP.get(`${this.IOTSRC}/health/${this.inverterId}/${type}?`)
        .then(response => {
          var respTime = [];
          var Chartdata = response.data;
          var temptime = Chartdata["Time"];
          temptime.forEach(element => {
            respTime.push(moment(element).format("Do MMM hh:mm"));
          });
          container.chartdata = {
            labels: respTime.reverse(),
            datasets: [
              {
                label: "Battery Voltage",
                backgroundColor: "rgba(255, 99, 132, 0.2)",
                data: Chartdata["BatteryVoltage"].reverse()
              },
              {
                label: "PV Charging Power",
                backgroundColor: "rgba(54, 162, 235, 0.2)",
                data: Chartdata["PVChargingPower"].reverse()
              },
              {
                label: "Battery Charging Current",
                backgroundColor: "rgba(255, 206, 86, 0.2)",
                data: Chartdata["BatteryChargingCurrent"].reverse()
              },
              {
                label: "Battery Capacity",
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                data: Chartdata["BatteryCapacity"].reverse()
              },
              {
                label: "Output Load Percent",
                backgroundColor: "rgba(153, 102, 255, 0.2)",
                data: Chartdata["OutputLoadPercent"].reverse()
              },
              {
                label: "Grid Voltage",
                backgroundColor: "rgba(255, 153, 0, 0.6)",
                data: Chartdata["GridVoltage"].reverse()
              },
              {
                label: "AC Output ActivePower",
                backgroundColor: "rgba(255, 159, 64, 0.2)",
                data: Chartdata["ACOutputActivePower"].reverse()
              }
            ]
          };
          container.charttype = "line";

          container.renderChart();
        })
        .catch(e => {
          //  console.log(e);
        });
    },
    expiryDate(deviceID) {
      const deviceExpiry = this.findDeviceData(
        this.DeviceList.expiries,
        "DeviceID",
        deviceID
      );

      return deviceExpiry !== undefined
        ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"])
        : "--";
    },
    findDeviceData(dataset, key, value) {
      const res = dataset.filter(x => x[key] == value);
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData() {
      let container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      let payLoad = {
        ":key": Number(this.inverterId)
      };
      let data = {
        TableName: "ConnectedDevices",
        FilterExpression: `DeviceID IN (${Object.keys(payLoad).toString()})`,
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };

      IOTHTTP.post(`/devicedata/scan`, data, {
        headers
      })
        .then(resp => {
          if (resp.data["Items"]) {
            let _tmpDevice = resp.data["Items"][0];
            let parsed = this.transformDashData(_tmpDevice);
            // this.Device = parsed;
            // this.transformDashData(_tmpDevice);
            //  console.log("++++++++>=", _tmpDevice);
          }
          // setInterval(this.fetchAllDeviceData, 60000);
          // console.log("++++++++>=",  resp.data['Items']);
        })
        .catch(err => {
          //  console.log("=++++++++>", err);
          // setInterval(this.fetchAllDeviceData, 3000);
        });
    },
    async graphDetailsCall(cid) {
      // 416813
      if (!cid) {
        return true;
      }

      const FastAPIHTTP = this.$httpUtils.FastAPIHTTP;
      await FastAPIHTTP.get(`/devices/${cid}`)
        .then(res => {
          console.log("---> V3 <----");
          let _tmpDevice = res.data.data.device["Items"][0];
          let parsed = this.transformDashData(_tmpDevice, res.data.data.device);
          // console.log(res);
          //  if (res.data.data["Items"]) {
          //   this.Device = {
          //     ...this.Device,
          //     parameters: resp.data["Items"][0]
          //   };
          //   console.log("++++++++>=", this.Device);
          // }
        })
        .catch(err => {
          console.log(err);
        });
    },
    groupKwhConversion(eIn) {
      // console.log({ eIn });

      Object.keys(eIn).map(x => {
        if (x != "InverterId") {
          eIn[x] = eIn[x] / 1000;
        }
      });

      return eIn;
      // console.log({ eIn });
    },
    handleSingularEnergyDataTransformation(singularEnergyData) {
      try {
        if (!singularEnergyData) {
          return [];
        }

        let { Data: energyData } = singularEnergyData;
        // console.log({ energyData });

        let edResp = energyData
          ? energyData.map(e => {
              // console.log({ e });
              if (!energyData) return {};
              let et = this.transformMapData(e);
              let gkc = this.groupKwhConversion(et);

              return gkc;
            })
          : [];

        this.singularEnergyData = edResp;
      } catch (error) {}
    },
    transformDashData(_tmpDevice, _completePayload = null) {
      // console.log({ _tmpDevice });
      let { payload } = _tmpDevice;
      let { MiscData, InverterDetected } = payload || {};
      this.MiscData = MiscData || {};
      // console.log({ MiscData, _completePayload });
      if (InverterDetected && InverterDetected === "NO") {
        this.$router.push({ name: "performance" });
      }
      let { EnergyData } = _tmpDevice.payload;
      let {
        currentSettings,
        EnergyData: singularEnergyData
      } = _completePayload;
      let currentSettingsAndDeviceId = currentSettings.map(x => ({
        ...x,
        DeviceID: this.inverterId
      }));
      // console.log({ currentSettingsAndDeviceId });
      this.$store.commit(
        "setDeviceCurrentSettings",
        this.transformListData(currentSettingsAndDeviceId || [])
      );

      // console.log({
      //   EnergyData:
      //     undefined === EnergyData
      //       ? null === _completePayload
      //         ? {}
      //         : _completePayload.transformedEnergyData
      //       : EnergyData
      // });

      EnergyData =
        parseFloat(MiscData.FV) >= 1.76 || MiscData.FV == 1.11
          ? _completePayload.transformedEnergyData
          : EnergyData;
      // console.log({
      //   testIsEnergyAvaialable: EnergyData[0] ? true : false
      // });

      this.handleSingularEnergyDataTransformation(singularEnergyData);

      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });
      this.EnergyData = this.transformMapData(
        EnergyData[0] ? EnergyData[0] : EnergyData
      );
      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });

      Object.keys(this.EnergyData).map(x => {
        this.EnergyData[x] = this.EnergyData[x] / 1000;
        return this.EnergyData[x];
      });
      // console.log(_tmpDevice.payload, "PAYLOAD");
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          InvAggrData: _tmpDevice.payload.InvAggrData,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"] || {},
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      // console.log("+++++DEBUG 02 +++>=", tmp_data);
      //this.inverter=_tmpDevice.payload.InverterData;
      this.Device = {
        ...tmp_data
        // EnergyData,
        // Timestamp: _tmpDevice.payload.Timestamp,
        // Mode: _tmpDevice.payload.ModeData[0]["Mode"],
        // InverterData: this.transformListData(_tmpDevice.payload.InverterData),
        // ModeData: this.transformListData(_tmpDevice.payload.ModeData),
        // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
        // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
        // BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
        // MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
      };
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    initFetch() {
      let { deviceId } = this.$route.params;
      this.graphDetailsCall(parseInt(deviceId));
      this.sleep(60000 * 3).then(() => {
        this.initFetch();
      });
      // this.initError = false;
      // var inverterId = this.inverterId * 1;
      // let _tmpDevice = this.DeviceList.devices.find(
      //   x => x.DeviceID == inverterId
      // );

      // if (_tmpDevice) {
      // console.log({_tmpDevice})
      // this.Device = {
      //   Timestamp: _tmpDevice.payload.Timestamp,
      //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
      //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
      //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
      //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
      //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
      //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
      //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
      //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
      // };
      // let parsed = this.transformDashData(_tmpDevice);
      // this.Device = parsed;
      // console.log(parsed);
      // } else {
      // this.initError = true;
      //  console.log(this.initError);
      // }
      // this.fetchAllDeviceData();
    },
    transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return Object.keys(MapData).reduce((cummData, key) => {
        let oldKey = payloadDictionary.find(x => x.new_key == key);
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData(ListData) {
      return ListData.map(x => {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? this.transformListData(x) : this.transformMapData(x);
      });
    },
    getDeviceState() {
      let container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      var FASTHTTP = this.$httpUtils.FastAPIHTTP;
      FASTHTTP.get(`/devicestate/${inverterId}`)
        .then(resp => {
          // console.log(resp.data.state.reported.userPower);
          if (resp.data.state.reported.userPower) {
            container.powerState = resp.data.state.reported.userPower;
          }
        })
        .catch(err => {
          //console.log(err)
        });
    },
    transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(
        (aggr, c_item) => {
          keys.map(key => {
            key == "SOC"
              ? (aggr[key] = [...aggr[key], c_item["BatteryData"][key]])
              : (aggr[key] = [...aggr[key], c_item["EnergyData"][key] / 1000]);
            //console.log("i am aggr",key,aggr[key]);
          });
          return aggr;
        },
        keys.reduce((ret, crr) => {
          ret[crr] = [];
          return ret;
        }, {})
      );
    },
    transformChartData(InverterDataList) {
      return InverterDataList.reduce((aggr, c_item) => {
        let tmpCurr = this.transformMapData(c_item);
        Object.keys(tmpCurr).map(singleKey => {
          aggr[singleKey] = aggr[singleKey]
            ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey])
            : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel(data) {
      return data.reduce((aggr, c_item) => {
        aggr = [
          ...aggr,
          moment(c_item["Timestamp"])
            .add(1, "hour")
            .format("MMM d YYYY - h:m:s A")
        ];
        return aggr;
      });
    },
    solarDataChart(displayData, labels) {
      let Chartdata = this.transformData(displayData, [
        "ACOutputActivePower",
        "SOC",
        "PVChargingPower"
      ]);
      // console.log({ Chartdata });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [
          {
            pointRadius: 0,
            label: "PV Charging Power",
            borderColor: "#109cf1",
            backgroundColor: "rgba(16, 156, 241,0.4)",
            data: Chartdata["PVChargingPower"]
          }
        ]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [
          {
            pointRadius: 0,
            //label: "Output Active Power",
            label: "Battery Percentage",
            borderColor: "#ffb946",
            backgroundColor: "rgba(255, 185, 70,0.3)",
            // backgroundColor: "transparent",
            data: Chartdata["SOC"]
          }
        ]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              scaleLabel: {
                display: true,
                labelString: "PV Charging Power (KW)"
              }
            }
          ]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true
              },
              scaleLabel: {
                display: true,
                labelString: "Battery Percentage (%)"
                //labelString: "AC Output Active Power (KW)"
              }
            }
          ]
        }
      };
      this.loading = false;
      this.renderChart();
    },
    async currentTime() {
      const HTTP = this.$httpUtils.instance;
      let response = await HTTP.get(
        "https://arnergy.com/weather-api/time/?" + Date.now()
      );
      // console.log(response.data.datetime);
      if (response) {
        if (response.data.datetime) {
          let tmpDate = response.data.datetime.split(".")[0];
          return tmpDate;
        } else {
          return null;
        }
      }
    },
    async DataToExportToTable(
      upperLimit = null,
      lowerLimit = null,
      limit = 100
    ) {
      this.timeRightNow = await this.currentTime();
      let container = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Parameters",
        KeyConditionExpression:
          "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": `${inverterId}`,
          ":up":
            upperLimit ||
            moment("2019/6/20")
              .startOf("day")
              .toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // return;

      console.log(data);
      IOTHTTP.post(`/devicedata`, data, {
        headers
      }).then(resp => {
        this.viewDataLoading = false;
        this.showTableOffCanvas = true;

        var exportedData = resp.data.Items.map(data => {
          return flatten(data);
        });
        console.log(exportedData);
        if (exportedData.length > 0) {
          let temp = Object.keys(exportedData[0]);
          this.exportDataTableoptions = Object.keys(exportedData[0]);
        }

        this.exportDataToTableValues = exportedData;
        let json2csvCallback = function(err, csv) {
          if (err) throw err;
          //return csv;
          var hiddenElement = document.createElement("a");
          hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
          hiddenElement.target = "_blank";
          hiddenElement.download =
            container.installationData.name + "_reports.csv";
          hiddenElement.click();
        };
        // converter.json2csv(exportedData, json2csvCallback);
      });
    },
    // showModal() {
    //   this.$refs["modal-scrollable"].show();
    // },
    // hideModal() {
    //   this.$refs["modal-scrollable"].hide();
    // },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    async DataToExport(upperLimit = null, lowerLimit = null, limit = 1000) {
      this.timeRightNow = await this.currentTime();
      this.exportDataloading = true;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Parameters",
        KeyConditionExpression:
          "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": `${inverterId}`,
          ":up":
            upperLimit ||
            moment("2019/6/20")
              .startOf("day")
              .toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      IOTHTTP.post(`/devicedata`, data, {
        headers
      }).then(resp => {
        this.viewDataLoading = false;
        this.exportDataLoading = false;
        var exportedData = resp.data.Items.map(data => {
          return flatten(data);
        });
        this.exportDataToTableValues = exportedData;
        this._convertJsonToCsvAndDownload(exportedData);
      });
    },
    _convertJsonToCsvAndDownload(arrJson) {
      let labels = Object.getOwnPropertyNames({ ...arrJson[0] });
      let labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      const csvLabels = this.$_createCsvLabels(labelsConf, ",");
      const csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      const content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error(`Error: An error occured while parsing the data.`);
        return;
      }

      let f = this.$_downloadCsv(
        `csv-export`,
        content,
        this.installationData.name || "CSV Export Data"
      );
      if (!f) console.error(`An error has occured`, hasErrorEvent);
    },
    async getDeviceData(upperLimit = null, lowerLimit = null, limit = 100) {
      this.timeRightNow = await this.currentTime();
      let container = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Parameters",
        KeyConditionExpression:
          "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": `${inverterId}`,
          ":up":
            upperLimit ||
            moment("2019/6/20")
              .startOf("day")
              .toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      IOTHTTP.post(`/devicedata`, data, {
        headers
      })
        .then(resp => {
          //this.exportedData = resp.data.Items;
          // console.log("+++++=",resp.data.Items[0]);
          let DevData = resp.data.Items.map(_tmpDevice => {
            // console.log(_tmpDevice);
            return {
              Timestamp: _tmpDevice.DeviceTimeStamp,
              InverterData: _tmpDevice.payload.InverterData,
              BatteryData: _tmpDevice.payload.BatteryData,
              EnergyData: this.transformChartData(
                _tmpDevice.payload.InverterData
              )
            };
          });
          this.inverter = DevData[0].InverterData;
          // let DevData = this.transformListData(tmpData);
          // console.log(resp.data.Items.map(x => ({ ...x.payload })));
          // console.log({ DevData });
          // this.batteryChart(DevData, this.getTimeLabel(DevData));
          this.solarDataChart(DevData, this.getTimeLabel(DevData));
          // console.log(resp.data.state.reported.userPower);
          // if (resp.data.state.reported.userPower) {
          //   container.powerState = resp.data.state.reported.userPower;
          // }
        })
        .catch(err => {
          //console.log(err)
        });
    },
    getDeviceWarnings() {
      let app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      let data = {
        TableName: "Warnings",
        KeyConditionExpression:
          "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": moment().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      IOTHTTP.post(`/devicedata`, data, {
        headers
      })
        .then(resp => {
          let DevData = this.transformListData(resp.data.Items);
          console.log({ DevData });
          // if (DevData[0]) {
          //   app.deviceWarning = DevData[0]["payload"];
          // }
          // console.log(this.getTimeLabel(DevData))
          // this.batteryChart(DevData, this.getTimeLabel(DevData));
          // this.solarDataChart(DevData, this.getTimeLabel(DevData));
          // console.log(resp.data.state.reported.userPower);
          // if (resp.data.state.reported.userPower) {
          //   container.powerState = resp.data.state.reported.userPower;
          // }
        })
        .catch(err => {
          //console.log(err)
        });
    },
    getDevice() {
      var inverterId = this.inverterId;
      const context = this;
      const HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=${inverterId}`;
      HTTP.get(url)
        .then(response => {
          if (response.data.length > 0)
            context.installationData = response.data[0];
          //console.log(response.data);
        })
        .catch(error => {
          return "not assign";
          //console.log("error", error);
        });
    }
  },
  created() {},
  async mounted() {
    console.log("----------------------------------------");
    this.getDevice();
    this.getDeviceData();
    try {
      this.initFetch();
    } catch (err) {
      console.log({ err });
      // window.location.reload();
    }
    // this.initError = false;
    // try {
    // await this.currentTime();
    //   this.refreshList().then(x => {
    //     console.log("=====================");
    //     // console.log(this.DeviceList);
    //     this.initFetch();

    //     this.getDeviceWarnings();
    //   });
    //   //   console.log(data);
    // } catch (error) {
    //   this.initError = true;
    //   console.log("Init Error", error);
    // }
    // this.fetchHealth("today");
    // this.statusBorder = "4px solid #000";
    // setInterval(this.fetchAllDeviceData, 60000);
  }
};
</script>

<style lang="scss" scoped>
ul {
  margin-top: 0px !important;
}
.info-div-inner .stats {
  flex-flow: column;
}

address {
  small {
    color: #9b9b9b;
    font-size: 0.75rem;
  }
}

.sm-font-size {
  font-size: 13px;
  margin-left: 13px;
}

.d-flex button {
  width: 100%;
}

button,
.vuestic-switch {
  margin-bottom: 1rem;
}

button,
button i {
  font-size: 0.7em;
}

.btn.btn-with-icon i {
  font-size: 1.5em;
}

.flatpickr-next-month,
.flatpickr-next-month.flatpickr-next-month {
  right: 0 !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.dash_details {
  background: #1a93ca;
  padding: 8px 15px;
  color: #ffffff;
  width: 100%;
  border-radius: 4px 4px 0px 0px;
}
.stats_header__title {
  font-size: 15px;
  color: #a2b5c5;
  font-weight: 600;
  letter-spacing: 0.13px;
}
._user-avatar {
  height: 48px;
  width: 48px;
  border-radius: 50%;
}
.power_stat_ {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.power_stat_row_ {
  display: flex;
  flex-flow: row;
  text-align: left;
  justify-content: space-between;
}
.stat_data_row {
  display: flex;
  justify-content: center;
  width: 100%;
}

@media (max-width: 1399px) {
  .col-xl-3.col-lg-3.col-md-6 {
    // width: 50% !important;
  }
}

.top-subtitle {
  font-size: 1rem !important;
}

.sadFaceIOT {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column nowrap;
  min-height: calc(100vh - 250px);
  color: #9b9b9b;
  text-align: center !important;
}
.inverter-details-box {
  display: flex;
  flex-flow: row;
}
.inverterInfo {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #ddd;
  padding: 5px;
}
.inverterId {
  padding: 2pt;
  font-weight: normal;
  font-size: 12pt;
}

.inverterId-label {
  padding: 2pt;
  font-weight: bold;
  font-size: 12pt;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/performance/detailsV2/v5.vue